// extracted by mini-css-extract-plugin
export var dividerLine = "_6w-3";
export var itemImage = "_6w-9";
export var lightDivider = "_6w-4";
export var modalContent = "_6w-5";
export var modalContentCompact = "_6w-6";
export var productCard = "_6w-a";
export var productImage = "_6w-b";
export var productImageCompact = "_6w-7";
export var productImagePlaceholder = "_6w-c";
export var productImagePlaceholderCompact = "_6w-8";
export var progressBarBackground = "_6w-1";
export var progressBarContainer = "_6w-0";
export var progressBarFill = "_6w-2";